export enum CastState {
	UNAVAILABLE = 'unavailable',
	AVAILABLE = 'available',
	CONNECTING = 'connecting',
	CONNECTED = 'connected',
}
